import attachValidation from '../../utils/form-validation';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import { getDataFromForm } from '../../utils/misc';
import Request from '../../utils/request';
import Select from '../../components/Select';

class SchoolWimbledonBallot {
	constructor() {
		this.state = {
			ballotDates: [],
			preferedFirstDate: { value: '', label: '' },
			preferedSecondDate: { value: '', label: '' },
			preferedThirdDate: { value: '', label: '' }
		};
		this._wrapper = SelectorEngine.findOne('.p-school-wimbledon-ballot');
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get ballotDates() {
		return this._ballotDates;
	}

	set ballotDates(ballotDates = []) {
		this._ballotDates = ballotDates;
		this._updateBallotDatesOne(); //Setting up the drop down with the dates received from Episerver all the three drop downs sharing the same dates.
		this._updateBallotDatesTwo();
		this._updateBallotDatesThree();
	}

	init() {
		this.loadBallotDates();
		this._form = SelectorEngine.findOne('.p-school-wimbledon-ballot__form', this._wrapper);
		this._preferredDatesWrapper = SelectorEngine.findOne('.p-school-wimbledon-ballot__preferred-dates', this._wrapper);
		const errorDismissCta = this._wrapper.querySelector('.p-school-wimbledon-ballot__error-btn');
		this._errorWrapper = this._wrapper.querySelector('.p-school-wimbledon-ballot__error');

		const validationError = SelectorEngine.findOne('.p-school-wimbledon-ballot__validation-error', this._wrapper);
		const validationErrorDate = SelectorEngine.findOne(
			'.p-school-wimbledon-ballot__validation-error-date',
			this._wrapper
		);

		const preferredDateOne = SelectorEngine.findOne('.preferred-date-one .js-lta-select', this._form);
		this.preferredDateOneElement = Select.getInstance(preferredDateOne) || new Select(preferredDateOne);
		EventHandler.on(
			this.preferredDateOneElement._selectNativeElement,
			'change',
			this.preferredDateOneValidation.bind(this)
		);

		const preferredDateTwo = SelectorEngine.findOne('.preferred-date-two .js-lta-select', this._form);
		this.preferredDateTwoElement = Select.getInstance(preferredDateTwo) || new Select(preferredDateTwo);
		EventHandler.on(
			this.preferredDateTwoElement._selectNativeElement,
			'change',
			this.preferredDateTwoValidation.bind(this)
		);

		const preferredDateThree = SelectorEngine.findOne('.preferred-date-three .js-lta-select', this._form);
		this.preferredDateThreeElement = Select.getInstance(preferredDateThree) || new Select(preferredDateThree);
		EventHandler.on(
			this.preferredDateThreeElement._selectNativeElement,
			'change',
			this.preferredDateThreeValidation.bind(this)
		);

		errorDismissCta.addEventListener('click', () => {
			this._errorWrapper.classList.add('u-hidden');
		});

		this._form.addEventListener('change', () => {
			this._openHiddenSection();
		});

		errorDismissCta.addEventListener('click', () => {
			this._errorWrapper.classList.add('u-hidden');
			location.reload();
		});

		this.fv = attachValidation(this._form, {
			'schoolWimbledonOptIn': {
				validators: {
					notEmpty: {
						message: validationError.innerHTML
					}
				}
			},
			'schoolPricedTickets': {
				validators: {
					notEmpty: {
						message: validationError.innerHTML
					}
				}
			},
			'preferred-date-one': {
				// validated conditionally if the schoolWimbledonOptIn is true this field is mandatory else not
				validators: {
					notEmpty: {
						message: validationErrorDate.innerHTML
					}
				}
			}
		});
		this.fv.on('core.form.valid', () => {
			this.submitEnquiry(this._form);
		});
	}

	_updateBallotDatesOne() {
		this.preferredDateOneElement.clearItems();
		const element = SelectorEngine.findOne('select', this.preferredDateOneElement._element);
		const selectedOption = this.state.preferedFirstDate.value
			? `<option value="${this.state.preferedFirstDate.value}" disabled="" selected="">${this.state.preferedFirstDate.label}</option>`
			: ``;
		const options = [
			`<option value="" disabled="" selected="">--Please select</option>`,
			selectedOption,
			...Object.keys(this.ballotDates).map((index) => {
				const ballotDates = this.ballotDates[index];
				return `<option value="${ballotDates.value}" ${ballotDates.value === element.value ? 'selected' : ``}>
							${ballotDates.label}
						</option>`;
			})
		].join('');
		element.innerHTML = options;
		this.preferredDateOneElement.generateItems();
	}

	_updateBallotDatesTwo() {
		this.preferredDateTwoElement.clearItems();
		const element = SelectorEngine.findOne('select', this.preferredDateTwoElement._element);
		const selectedOption = this.state.preferedSecondDate.value
			? `<option value="${this.state.preferedSecondDate.value}" disabled="" selected="">${this.state.preferedSecondDate.label}</option>`
			: ``;
		const options = [
			`<option value="" disabled="" selected="">--Please select</option>`,
			selectedOption,
			...Object.keys(this.ballotDates).map((index) => {
				const ballotDates = this.ballotDates[index];
				return `<option value="${ballotDates.value}" ${ballotDates.value === element.value ? 'selected' : ``}>
							${ballotDates.label}
						</option>`;
			})
		].join('');
		element.innerHTML = options;
		this.preferredDateTwoElement.generateItems();
	}

	_updateBallotDatesThree() {
		this.preferredDateThreeElement.clearItems();
		const element = SelectorEngine.findOne('select', this.preferredDateThreeElement._element);
		const selectedOption = this.state.preferedThirdDate.value
			? `<option value="${this.state.preferedThirdDate.value}" disabled="" selected="">${this.state.preferedThirdDate.label}</option>`
			: ``;
		const options = [
			`<option value="" disabled="" selected="">--Please select</option>`,
			selectedOption,
			...Object.keys(this.ballotDates).map((index) => {
				const ballotDates = this.ballotDates[index];
				return `<option value="${ballotDates.value}" ${ballotDates.value === element.value ? 'selected' : ``}>
							${ballotDates.label}
						</option>`;
			})
		].join('');
		element.innerHTML = options;
		this.preferredDateThreeElement.generateItems();
	}

	async loadBallotDates() {
		await Request.get('/api/wimbledonballot/getavailabledates') // Requesting the preferred dates from Episerver
			.catch((error) => {
			console.error(error);
			})
			.then((response) => {
				this.state.ballotDates = response.PreferredDates;
				this.ballotDates = this.state.ballotDates;
			});
	}

	_openHiddenSection() {
		const schoolWimbledonOptIn = SelectorEngine.findOne('input[name = "schoolWimbledonOptIn"]:checked', this._wrapper);
		if (schoolWimbledonOptIn.value == 'True') {
			this._preferredDatesWrapper.classList.remove('u-hidden');
			this.fv.enableValidator('preferred-date-one'); // enabling the validator if schoolWimbledonOptIn is true
		} else {
			this._preferredDatesWrapper.classList.add('u-hidden');
			this.fv.disableValidator('preferred-date-one'); // disabling the validator if schoolWimbledonOptIn is false
		}
	}

	async submitEnquiry(form) {
		const dataObject = getDataFromForm(form);
		const anyDayFlag = dataObject.schoolWimbledonOptIn == 'True' ? true : false;
		const centreCourtFlag = dataObject.schoolPricedTickets == 'True' ? true : false;
		if (!anyDayFlag) {
			this.state.preferedFirstDate.value = undefined;
			this.state.preferedSecondDate.value = undefined;
			this.state.preferedThirdDate.value = undefined;
			this.state.preferedFirstDate.label = undefined;
			this.state.preferedSecondDate.label = undefined;
			this.state.preferedThirdDate.label = undefined;
		}

		const finalData = Object.assign({
			anyDayFlag: anyDayFlag,
			centreCourtFlag: centreCourtFlag,
			day1Preference: this.state.preferedFirstDate.value,
			day2Preference: this.state.preferedSecondDate.value,
			day3Preference: this.state.preferedThirdDate.value,
			date1: this.state.preferedFirstDate.label,
			date2: this.state.preferedSecondDate.label,
			date3: this.state.preferedThirdDate.label
		});

		await Request.post('/api/wimbledonballot/submitPreferredDates', finalData).catch((error) => {
			if (error?.error?.errorCode == '00') {
				location.reload();
			} else {
				console.log(error);
				this._errorWrapper.classList.remove('u-hidden');
				this._errorWrapper.scrollIntoView();
			}
		});
	}

	// As the three dropdowns sharing the same ballot dates.
	// Each and every dropdown should be selected with unique value.
	// If one value is selected in dropdown the same value should be removed from another two dropdowns vice versa.

	reArrangeBallotDates() {
		const reArrangeDates = this._ballotDates;
		function compareNumbers(a, b) {
			return a.value - b.value;
		}
		reArrangeDates.sort(compareNumbers); // ['9', '80', '700']
	}

	setBallotDate(value, label) {
		this._ballotDates.push({
			value: value,
			label: label
		});
		this.state.ballotDates = this._ballotDates;
		this.reArrangeBallotDates();
	}

	removeFromBallot(value) {
		const newArr = this.state.ballotDates.filter((object) => {
			return object.value !== value;
		});
		this.state.ballotDates = newArr;
		this._ballotDates = this.state.ballotDates;
	}

	preferredDateOneValidation() {
		const preferredDate = this.preferredDateOneElement._selectNativeElement.value;
		const preferredDateId = SelectorEngine.findOne('#preferred-date-one');
		const preferredDateLabel = preferredDateId.options[preferredDateId.selectedIndex].innerHTML.trim();

		if (this.state.preferedFirstDate.value) {
			this.setBallotDate(this.state.preferedFirstDate.value, this.state.preferedFirstDate.label);
		}
		this.state.preferedFirstDate.value = preferredDate;
		this.state.preferedFirstDate.label = preferredDateLabel;
		if (preferredDate) {
			this.removeFromBallot(this.state.preferedFirstDate.value);
		}
		this._updateBallotDatesOne(); // updating the drop down values after each selection as all the three sharing same dropdown values.
		this._updateBallotDatesTwo();
		this._updateBallotDatesThree();
	}

	preferredDateTwoValidation() {
		const preferredDate = this.preferredDateTwoElement._selectNativeElement.value;
		const preferredDateId = SelectorEngine.findOne('#preferred-date-two');
		const preferredDateLabel = preferredDateId.options[preferredDateId.selectedIndex].innerHTML.trim();

		if (this.state.preferedSecondDate.value) {
			this.setBallotDate(this.state.preferedSecondDate.value, this.state.preferedSecondDate.label);
		}
		this.state.preferedSecondDate.value = preferredDate;
		this.state.preferedSecondDate.label = preferredDateLabel;
		if (preferredDate) {
			this.removeFromBallot(this.state.preferedSecondDate.value);
		}
		this._updateBallotDatesOne();
		this._updateBallotDatesTwo();
		this._updateBallotDatesThree();
	}

	preferredDateThreeValidation() {
		const preferredDate = this.preferredDateThreeElement._selectNativeElement.value;
		const preferredDateId = SelectorEngine.findOne('#preferred-date-three');
		const preferredDateLabel = preferredDateId.options[preferredDateId.selectedIndex].innerHTML.trim();

		if (this.state.preferedThirdDate.value) {
			this.setBallotDate(this.state.preferedThirdDate.value, this.state.preferedThirdDate.label);
		}
		this.state.preferedThirdDate.value = preferredDate;
		this.state.preferedThirdDate.label = preferredDateLabel;
		if (preferredDate) {
			this.removeFromBallot(this.state.preferedThirdDate.value);
		}
		this._updateBallotDatesOne();
		this._updateBallotDatesTwo();
		this._updateBallotDatesThree();
	}
}

const schoolwimbledonballot = new SchoolWimbledonBallot();
export default schoolwimbledonballot;
